import { useLayoutEffect, useRef } from 'react';

import { useImpersonatorEmailFromStorage } from '@/services/storage';

const useImpostorRefresh = () => {
  const impostorEmail = useImpersonatorEmailFromStorage();
  const prevImpostorEmailRef = useRef<string | null | undefined>(undefined);

  useLayoutEffect(() => {
    if (prevImpostorEmailRef.current === undefined) {
      prevImpostorEmailRef.current = impostorEmail;
      return;
    }
    if (prevImpostorEmailRef.current !== impostorEmail) {
      prevImpostorEmailRef.current = impostorEmail;
      setTimeout(() => {
        window.location.href = '/';
      }, 250);
    }
  }, [impostorEmail]);
};

export default useImpostorRefresh;
